<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px" class="bg-white p-1">
            <el-form-item label="标题" prop="title">
                <el-input v-model="queryParams.query.title" placeholder="请输入标题" clearable size="small"
                    style="width: 240px" @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="所属位置" prop="moduleType">
                <el-select v-model="queryParams.query.moduleType" placeholder="请选择所属位置" clearable
                    size="small" style="width: 200px">
                    <el-option v-for="item in placeOptions" :key="item.dictValue" :label="item.dictLabel"
                        :value="String(item.dictValue)" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8 my-1">
            <el-col :span="1.5">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
            </el-col>
        </el-row>

        <el-table v-loading="searchLoading" :data="list" :header-cell-style="{ background: '#DDD' }">
            <el-table-column label="图标" align="center" width="100">
                <template v-slot="scope">
                    <el-image v-if="scope.row.iconUrl" style="width: 40px; height: 40px"
                        :src="imageUrlprefix + scope.row.iconUrl"
                        :preview-src-list="[imageUrlprefix + scope.row.iconUrl]" fit="cover" lazy />
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" prop="title" :show-overflow-tooltip="true" />
            <el-table-column label="所属位置" align="center" prop="moduleType" :show-overflow-tooltip="true">
                <template v-slot="scope">
                    <span>{{ placeLabel(scope.row.moduleType) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="排序" align="center" prop="sort" width="80" />
            <el-table-column label="页面地址" align="center" prop="pageUrl" :show-overflow-tooltip="true" />
            <el-table-column label="携带参数" align="center" prop="carryParam" :show-overflow-tooltip="true" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
                <template v-slot="scope">
                    <el-button size="mini" type="text" icon="el-icon-edit"
                        @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button size="mini" type="text" icon="el-icon-delete"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />

        <el-dialog :title="dialogTitle" :visible.sync="open" width="520px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入标题" maxlength="50" />
                </el-form-item>
                <el-form-item label="图标" prop="iconUrl">
                    <el-upload class="avatar-uploader" action :show-file-list="false" :http-request="imgUpload"
                        :before-upload="beforeUpload">
                        <img v-if="form.iconUrl" :src="imageUrlprefix + form.iconUrl" class="avatar"
                            style="width: 148px; height: 148px" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div style="color: black; text-align: center; width: 156px" v-if="form.iconUrl">点击图片更换</div>
                </el-form-item>
                <el-form-item label="页面地址" prop="pageUrl">
                    <el-input v-model="form.pageUrl" placeholder="请输入小程序页面地址，如 /pages/xxx/index" />
                </el-form-item>
                <el-form-item label="携带参数" prop="carryParam">
                    <el-input v-model="form.carryParam" placeholder="如 id=1&type=2 或 JSON 字符串" />
                </el-form-item>
                <el-form-item label="所属位置" prop="moduleType">
                    <el-select v-model="form.moduleType" placeholder="请选择所属位置" clearable style="width: 100%">
                        <el-option v-for="item in placeOptions" :key="String(item.dictValue)" :label="item.dictLabel"
                            :value="String(item.dictValue)" />
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="form.sort" controls-position="right" :min="0" style="width: 100%" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    commonFunctionPage,
    commonFunctionDetail,
    commonFunctionAdd,
    commonFunctionUpdate,
    commonFunctionDelete
} from '@/api/sys/commonFunction'
import { uploadFile } from '@/api/upload/upload'
import { getListByDictType } from '@/api/sys/dictData'

export default {
    name: 'Settings',
    data() {
        return {
            searchLoading: true,
            submitLoading: false,
            list: [],
            total: 0,
            dialogTitle: '',
            open: false,
            form: {},
            placeOptions: [],
            rules: {
                title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
                iconUrl: [{ required: true, message: '请上传图标', trigger: 'change' }],
                pageUrl: [{ required: true, message: '页面地址不能为空', trigger: 'blur' }],
                moduleType: [{ required: true, message: '请选择所属位置', trigger: 'change' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            },
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                query: {
                    title: undefined,
                    moduleType: undefined
                }
            }
        }
    },
    created() {
        this.loadPlaceOptions()
        this.getList()
    },
    methods: {
        async loadPlaceOptions() {
            const res = await getListByDictType('sys_place')
            if (res && res.code === 200 && res.data) {
                this.placeOptions = (res.data || []).map((item) => ({
                    ...item,
                    dictValue: String(item.dictValue)
                }))
            }
        },
        toModuleTypeStr(value) {
            if (value === undefined || value === null || value === '') return undefined
            return String(value)
        },
        placeLabel(value) {
            if (value === undefined || value === null || value === '') return '-'
            const item = this.placeOptions.find((d) => String(d.dictValue) === String(value))
            return item ? item.dictLabel : value
        },
        getList() {
            this.searchLoading = true
            commonFunctionPage(this.queryParams)
                .then((response) => {
                    if (response && response.code === 200) {
                        const data = response.data
                        if (Array.isArray(data)) {
                            this.list = data
                            this.total = response.total != null ? response.total : data.length
                        } else {
                            this.list = (data && data.rows) || []
                            this.total = (data && data.total) || 0
                        }
                    }
                })
                .finally(() => {
                    this.searchLoading = false
                })
        },
        handleQuery() {
            this.queryParams.pageNum = 1
            this.getList()
        },
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                query: {
                    title: undefined,
                    moduleType: undefined
                }
            }
            this.resetForm('queryForm')
            this.handleQuery()
        },
        handleAdd() {
            this.reset()
            this.open = true
            this.dialogTitle = '新增常用功能'
        },
        handleUpdate(row) {
            this.reset()
            commonFunctionDetail({ id: row.id }).then((res) => {
                if (res && res.code === 200 && res.data) {
                    const d = res.data
                    this.form = {
                        id: d.id,
                        title: d.title,
                        iconUrl: d.iconUrl,
                        pageUrl: d.pageUrl,
                        carryParam: d.carryParam,
                        moduleType: this.toModuleTypeStr(d.moduleType),
                        sort: d.sort != null ? d.sort : 0
                    }
                    this.open = true
                    this.dialogTitle = '修改常用功能'
                }
            })
        },
        handleDelete(row) {
            this.$confirm('是否确认删除该数据项?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => commonFunctionDelete({ id: row.id }))
                .then((res) => {
                    if (res && res.code === 200) {
                        this.getList()
                        this.msgSuccess('删除成功')
                    }
                })
                .catch(() => { })
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return
                const payload = {
                    title: this.form.title,
                    iconUrl: this.form.iconUrl,
                    pageUrl: this.form.pageUrl,
                    carryParam: this.form.carryParam || '',
                    moduleType: this.toModuleTypeStr(this.form.moduleType),
                    sort: this.form.sort
                }
                this.submitLoading = true
                const req =
                    this.form.id !== undefined
                        ? commonFunctionUpdate({ ...payload, id: this.form.id })
                        : commonFunctionAdd(payload)
                req
                    .then((res) => {
                        if (res && res.code === 200) {
                            this.msgSuccess(this.form.id !== undefined ? '修改成功' : '新增成功')
                            this.open = false
                            this.getList()
                        }
                    })
                    .finally(() => {
                        this.submitLoading = false
                    })
            })
        },
        reset() {
            this.form = {
                id: undefined,
                title: undefined,
                iconUrl: undefined,
                pageUrl: undefined,
                carryParam: undefined,
                moduleType: undefined,
                sort: 0
            }
            this.resetForm('form')
        },
        cancel() {
            this.open = false
            this.reset()
        },
        imgUpload({ file }) {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('type', 'common_function_icon')
            uploadFile(formData).then((res) => {
                if (res.code === 200) {
                    this.form.iconUrl = res.data.url
                    this.$refs.form && this.$refs.form.validateField('iconUrl')
                    this.$forceUpdate()
                }
            })
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
            const isLt10M = file.size / 1024 / 1024 < 10
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG JPEG PNG 格式!')
            }
            if (!isLt10M) {
                this.$message.error('上传图片大小不能超过 10MB!')
            }
            return isJPG && isLt10M
        }
    }
}
</script>

<style scoped>
/deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 146px;
    height: 146px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 146px;
    height: 146px;
    line-height: 146px;
    text-align: center;
}
</style>
